import Vue from 'vue'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFroala from 'vue-froala-wysiwyg'
import VueAppInsights from 'vue-application-insights'
// import VueI18n from 'vue-i18n'
// import messages from './locales'
import i18n from './i18n'
import Default from './layouts/Default.vue'
import NoNav from './layouts/NoNav.vue'

import dayjs from 'dayjs'

// cSpell:disable

// Require Froala Editor js file.
import 'froala-editor/js/plugins.pkgd.min' // all plugins (you can add plugins by one too)
// require('froala-editor/js/froala_editor.pkgd.min')
import 'froala-editor/js/third_party/embedly.min'
import 'froala-editor/js/plugins/image_manager.min'

// Require Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css' // all styles (also for buttons)
// require('froala-editor/css/froala_editor.pkgd.min.css')
// require('froala-editor/css/froala_style.min.css')
import 'froala-editor/css/third_party/embedly.min.css'
import 'froala-editor/css/plugins/image_manager.min.css'
require('dayjs/locale/es')
require('dayjs/locale/fr')
require('dayjs/locale/el')
require('dayjs/locale/nl')
require('dayjs/locale/ru')

// https://github.com/NansenHo/dayjs-demo-vue2/blob/main/src/main.js
let utc = require('dayjs/plugin/utc')
let timezone = require('dayjs/plugin/timezone')
let advancedFormat = require('dayjs/plugin/advancedFormat')
let localizedFormat = require('dayjs/plugin/localizedFormat')
var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)
dayjs.locale(i18n.locale)

Vue.component('default-layout', Default)
Vue.component('no-nav-layout', NoNav)

// Import and use Vue Froala lib.
Vue.use(VueFroala)

Vue.use(BootstrapVue)

Vue.use(dayjs)
Vue.prototype.$dayjs = dayjs

// YOU CAN USE THE FOLLOWING IN A VUE.  DOESN'T HAVE TO BE USED IN MAIN.JS
// https://github.com/microsoft/applicationinsights-js#sending-telemetry-to-the-azure-portal
// https://www.npmjs.com/package/vue-application-insights#get-started
// this.$appInsights.trackEvent({ name: 'custom_name_event', properties: { property0: 'value0', property1: 'value1', property2: 'value2' } })

// https://github.com/microsoft/applicationinsights-js#configuration
Vue.use(VueAppInsights, {
  baseName: 'My Event Cafe',
  id: process.env.VUE_APP_APPLICATION_INSIGHTS,
  router,
  appInsightsConfig: {
    disableAjaxTracking: true
  }
})

if (window.Cypress) {
  window.__store__ = store
}

axios.interceptors.request.use(config => {
  if (Object.keys(store.getters.userProfile).length !== 0 && store.getters.userExpired) {
    console.log('Updating Profile')
    store.dispatch('updateProfile')
  }
  if (store.getters.token) {
    // console.log('Setting token in interceptor -> Bearer ' + store.getters.token.slice(0, 50))
    config.headers['Authorization'] = 'Bearer ' + store.getters.token
  }
  return config
}, error => {
  console.log('Request Error: ' + error)
  // store.dispatch('logout')
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, async (error) => {
  // Return any error which is not due to authentication back to the calling service
  if (error.response.status !== 401) {
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }

  // Logout user if token refresh didn't work or user is disabled
  // console.log('Error Config: ' + JSON.stringify(error.config))
  if (error.config.url.endsWith('/api/Authentication/refresh') || error.response.message === 'Account is disabled.') {
    console.log('401 Response Error: ' + error)
    store.dispatch('logout')
    router.push('/login')
  }

  // https://blog.liplex.de/axios-interceptor-to-refresh-jwt-token-after-expiration/
  // https://medium.com/@zitko/structuring-a-vue-project-authentication-87032e5bfe16
  console.log('Initiating Refresh User')
  await store.dispatch('refreshUser') // dispatch is synchronous, but we are returning a shared promise, so let's wait until user it's finished.
  console.log('Refresh user finished')
  store.commit('refreshTokenPromise', null)
  const config = error.config
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.token
  console.log('2nd Try')
  return new Promise((resolve, reject) => {
    axios.request(config).then(response => {
      resolve(response)
    }).catch((error) => {
      console.log('2nd Try Error: ' + JSON.stringify(error))
      reject(error)
    })
  })
})

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
